import React from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import {
    openModal,
} from 'state/actions'

import {
    getCurrentUser,
    getCurrentAccount,
    getApplicableProjects,
} from 'state/selectors'

import DashboardCalendar from 'sections/dashboard/dashboard-calendar'

const TeamCalendar = ({
    accountData,
    allTasks,
    allProjects,
    allMilestones,
    allFolders,
    userData,
    history,
    match,
    openModal
}) => {
    return (
        <div className="dashboard-container">
            <main>
                <DashboardCalendar
                    accountData={accountData}
                    showUserselector
                    allTasks={allTasks}
                    allProjects={allProjects}
                    allMilestones={allMilestones}
                    allFolders={allFolders}
                    userData={userData}
                    history={history}
                    match={match}
                    openModal={openModal}
                />
            </main>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        accountData: getCurrentAccount(state),
        allTasks: state.account.entities.tasks,
        allMilestones: state.account.entities.milestones,
        allProjects: getApplicableProjects(state),
        allFolders: state.account.entities.folders,
        userData: getCurrentUser(state),
    }
}

export default withRouter(connect(mapStateToProps, {
    openModal,
})(TeamCalendar))


// WEBPACK FOOTER //
// ./src/sections/planning/team-calendar.jsx